import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'

interface UseGetGroupMembersOptions {
  groupId: string | undefined
  enabled?: boolean
}

export const useGetGroupMembers = ({ groupId, enabled = true }: UseGetGroupMembersOptions) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: ['getGroupMembers', groupId],
    queryFn: async () => {
      if (!groupId) return { members: [] }

      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data } = await apiClient.GET('/groups/{groupId}/members', {
        params: { path: { groupId } },
      })

      return data
    },
    enabled: enabled && Boolean(groupId),
  })
}
